var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedreviews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "url(#paint0_linear_3025_3819)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3025_3819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7499 17.0003L16.2499 18.5003L19.2499 15.5003M10.8874 14.4653C10.7779 13.9722 10.7947 13.4594 10.9363 12.9746C11.0778 12.4897 11.3395 12.0484 11.697 11.6916C12.0545 11.3348 12.4964 11.0741 12.9816 10.9336C13.4667 10.7931 13.9795 10.7773 14.4724 10.8878C14.7437 10.4635 15.1174 10.1144 15.5591 9.87253C16.0008 9.63068 16.4963 9.50391 16.9999 9.50391C17.5035 9.50391 17.999 9.63068 18.4407 9.87253C18.8824 10.1144 19.2561 10.4635 19.5274 10.8878C20.021 10.7768 20.5347 10.7925 21.0206 10.9334C21.5066 11.0742 21.949 11.3357 22.3068 11.6934C22.6645 12.0512 22.926 12.4936 23.0669 12.9796C23.2077 13.4655 23.2234 13.9792 23.1124 14.4728C23.5367 14.7441 23.8858 15.1178 24.1277 15.5595C24.3695 16.0012 24.4963 16.4967 24.4963 17.0003C24.4963 17.5039 24.3695 17.9994 24.1277 18.4411C23.8858 18.8828 23.5367 19.2565 23.1124 19.5278C23.2229 20.0207 23.2072 20.5335 23.0667 21.0187C22.9261 21.5038 22.6654 21.9457 22.3086 22.3032C21.9518 22.6608 21.5105 22.9224 21.0256 23.0639C20.5408 23.2055 20.028 23.2223 19.5349 23.1128C19.264 23.5387 18.89 23.8894 18.4475 24.1323C18.005 24.3752 17.5084 24.5026 17.0037 24.5026C16.4989 24.5026 16.0023 24.3752 15.5598 24.1323C15.1173 23.8894 14.7433 23.5387 14.4724 23.1128C13.9795 23.2233 13.4667 23.2076 12.9816 23.0671C12.4964 22.9266 12.0545 22.6658 11.697 22.309C11.3395 21.9522 11.0778 21.5109 10.9363 21.0261C10.7947 20.5412 10.7779 20.0284 10.8874 19.5353C10.4599 19.2647 10.1077 18.8904 9.86369 18.4472C9.61966 18.004 9.4917 17.5063 9.4917 17.0003C9.4917 16.4944 9.61966 15.9966 9.86369 15.5534C10.1077 15.1102 10.4599 14.7359 10.8874 14.4653Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3025_3819",
    x1: 0,
    y1: 17,
    x2: 34,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F5BFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3025_3819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedreviews);
export default __webpack_public_path__ + "static/media/verifiedreviews.7276bc05f2ba96ef7650ebdc46e8c9fa.svg";
export { ForwardRef as ReactComponent };